module.exports = __webpack_public_path__ + "img/002.b600146b.png";